import Vue from 'vue'

/**
 * 设置基础URL
 */
let base = '/apiv1/options'

/**
 * 查询系统参数
 */
export const query = (params) => {
  return Vue.fetch.post(`${base}/query`, params).then(data => {
    return data
  })
}

/**
 * 新增系统参数
 * @param {*} params
 */
export const add = (params) => {
  return Vue.fetch.post(`${base}/add`, params)
}

/**
 * 修改系统参数
 * @param {*} params
 */
export const update = (params) => {
  return Vue.fetch.post(`${base}/update`, params)
}

/**
 * 删除系统参数
 * @param {*} params
 */
export const remove = (params) => {
  return Vue.fetch.post(`${base}/remove`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/options.js